import { AdvancedMarker, Pin } from "@vis.gl/react-google-maps";
import { memo, useCallback } from "react";
import { PIN_STYLES } from "./mapConstants";

const AgenciaMarker = memo(function AgenciaMarker({ marker, selectedId, onSelectAgencia }) {
  const isSelected = selectedId !== "" && String(marker.id) === selectedId;
  const pinStyle = isSelected ? PIN_STYLES.agenciaSelected : PIN_STYLES.agencia;

  const handleClick = useCallback(() => {
    onSelectAgencia?.(marker.id);
  }, [marker.id, onSelectAgencia]);

  return (
    <AdvancedMarker
      clickable={Boolean(onSelectAgencia)}
      onClick={onSelectAgencia ? handleClick : undefined}
      position={marker.location}
      title={marker.label}
      zIndex={isSelected ? 3 : 2}>
      <Pin {...pinStyle} />
    </AdvancedMarker>
  );
});

export default AgenciaMarker;
